import { useEffect, useRef } from 'react';

const INACTIVITY_LIMIT = 3 * 60 * 1000; // 30 minutes
const STORAGE_KEY = 'userActive';

const useInactivityTracker = () => {
  const timerRef = useRef(null);
  const setUserActive = () => {
    localStorage.setItem(STORAGE_KEY, JSON.stringify({
      status: 'true',
      updatedAt: Date.now(),
    }));
  };
  
  const setUserInactive = () => {
    localStorage.setItem(STORAGE_KEY, JSON.stringify({
      status: 'false',
      updatedAt: Date.now(),
    }));
  };

  const resetInactivityTimer = () => {
    // console.log('User activity Activity detected. Resetting timer.');
    clearTimeout(timerRef.current);
    setUserActive();

    timerRef.current = setTimeout(() => {
      setUserInactive();
    }, INACTIVITY_LIMIT);
  };

  useEffect(() => {
    const events = ['mousemove', 'mousedown', 'keydown', 'scroll', 'wheel', 'touchstart'];

    events.forEach((event) => {
      window.addEventListener(event, resetInactivityTimer, true);
    });

    // Initial timer setup
    resetInactivityTimer();

    return () => {
      events.forEach((event) => {
        window.removeEventListener(event, resetInactivityTimer, true);
      });
      clearTimeout(timerRef.current);
    };
  }, []);
};

export default useInactivityTracker;
